import { api, method } from '../api/apiClient';

export const getMenuDetails = async (payload) => {
    try {
        return await api(method.POST, `/order/menu`, payload);
    } catch (error) {
        console.error(`Error while fetching menu card details ${error}`);
        throw error;
    }
};

export const placeOrder = async (payload) => {
    try {
        return await api(method.POST, '/order', payload);
    } catch (error) {
        console.error(`Error in placing order ${error}`);
        throw error;
    }
};

export const notifyUsers = async (payload) => {
    try {
        return await api(method.POST, '/order/notify', payload);
    } catch (error) {
        console.error(`Error in notifying manager ${error}`);
        throw error;
    }
};

export const getCurrentOrder = async (tokenCode) => {
    try {
        return await api(method.GET, `/order/current?tokenCode=${encodeURIComponent(tokenCode)}`);
    } catch (error) {
        console.error(`Error in fetching current order details ${error}`);
        throw error;
    }
};

export const getRatingsData = async (payload) => {
    try {
        return await api(method.POST, '/order/ratings', payload);
    } catch (error) {
        console.error(`Error in fetching ratings data ${error}`);
        throw error;
    }
};
